export const selectPartnerInfo = (state: ReduxState) => state.partner;

export const selectChannelPartnerGuid = (state: ReduxState) => selectPartnerInfo(state)?.id;

export const selectPartnerAgencyExternalId = (state: ReduxState) => selectPartnerInfo(state)?.agencyExternalId;

export const getPartnerFromApplication = (state: ReduxState) => state.partnerFromApplication || {};
export const getPartnerIdFromApplication = (state: ReduxState) => getPartnerFromApplication(state)?.id;
